var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCategory5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 37,
    viewBox: "0 0 51 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.83203 36.3418C6.83203 33.5026 7.61012 30.9568 9.16631 28.7043C10.7225 26.4519 12.7341 24.8146 15.2013 23.7925L14.6319 18.1709H6.83203V4.54273H0V0H18.2188V4.54273H11.3867V13.6282H14.1195L13.6641 9.08545H36.4375L35.982 13.6282H38.7148V4.54273H31.8828V0H50.1585V4.54273H43.3265V18.1709H35.5266L34.9572 23.7925C37.4244 24.8146 39.4265 26.4519 40.9637 28.7043C42.5009 30.9568 43.2695 33.5026 43.2695 36.3418H38.7148C38.7148 33.8433 37.8229 31.7044 36.039 29.9252C34.255 28.146 32.1105 27.2564 29.6055 27.2564H20.4961C17.991 27.2564 15.8465 28.146 14.0626 29.9252C12.2787 31.7044 11.3867 33.8433 11.3867 36.3418H6.83203ZM19.6421 22.7136H30.4025L31.3704 13.6282H18.6742L19.6421 22.7136Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategory5);
export default __webpack_public_path__ + "static/media/category-5.3f7e1075170ffd1ce1b1c49c0b6fa2bd.svg";
export { ForwardRef as ReactComponent };